import { FetchFilingResponse, RowFiling, FetchFilingResult, AddFilingResult, AddFilingResponse, FilingData, UploadExcelResponse, UploadExcelResult, UpdateDTRResponse, UpdateDTRResult} from "./constant"
export function isFetchFilingResponse(result: FetchFilingResult): result is FetchFilingResponse {
    return result.success === true; 
  }

export function isUploadExcelResponse(result: UploadExcelResult): result is UploadExcelResponse {
  return result.success === true; 
}

export function isAddFilingResponse(result: AddFilingResult): result is AddFilingResponse {
    return result.success === true; 
}

export function isUpdateDTRResponse(result: UpdateDTRResult): result is UpdateDTRResponse {
    return result.success === true; 
}

export function formatToTwoDecimals (num: number): string  {
  return num.toFixed(2)
};

export function convertToRowFiling(responses: FilingData[], slcodes: { [key: string]: string }): RowFiling[] {

    const rowFilings: RowFiling[] = [];
    responses.forEach((item) => {
        const row: RowFiling = convertToRow(item, slcodes)
        rowFilings.push(row);
      });
    return rowFilings;
}

export function convertToRow(rowData: FilingData, slcodes: { [key: string]: string }): RowFiling {
  // console.log(`id: ${rowData.id}`)
  const row: RowFiling = {
      validate: rowData.warning,
      id: rowData.id,
      late: rowData.late,
      policynumber: rowData.policyNumber,
      transType: rowData.transType,
      insuredName: rowData.insuredName,
      insuredAddress: rowData.insuredAddress,
      transEffectiveDate: new Date(rowData.transEffectiveDate),
      policyEffectiveDate: new Date(rowData.policyEffectiveDate),
      transDate: new Date(rowData.transDate),
      slCode: slcodes[rowData.slCode],
      premium:formatToTwoDecimals(rowData.premium),
      policyFee:formatToTwoDecimals(rowData.policyFee),
      tax: formatToTwoDecimals(rowData.tax),
      stampingFee:formatToTwoDecimals(rowData.stampingFee),
      latefee:formatToTwoDecimals(rowData.latefee),
      period: rowData.period,
      carriers:rowData.carriers.map(carrier => `${carrier.name}(${carrier.percent}%)`).join(" / "),
  };

  return row;
}

export function parsingCarrier(instr : string) : string[]{
  const match = instr.match(/(.*?)(\(\d+(\.\d+)?%\))/)
  if (match) {
      return [match[1].trim(),  match[2].replace(/[()%]/g, '')];
  }
  return [];
}


export function  convertTimezoneToPst(date: Date): Date {
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const localDate = new Date(date.getTime() + userTimezoneOffset + 8 * 3600000);
  return localDate;
}

export function  convertLocalToEst(date: Date): Date {
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const localDate = new Date(date.getTime() + userTimezoneOffset - 5 * 3600000);
  return localDate;
}

export function getStringfromDate(date: Date): string {
  const dateData = new Date(date);
  const dateString = dateData.toLocaleDateString('en-US');
  return dateString;
}